module.exports = __webpack_public_path__ + "img/horror-short.8e5fa287.webp";